export interface ILanguage {
  [key: string]: string;
}

const baseLanguage: ILanguage = {
  /** Routes */
  home: "/home",
  about: "/about",
  projectsMy: "/projects/my",
  detector: "/detector",
  templates: "/templates",
  register: "/register",
  registerConfirmation: "/register/confirmation",
  accountActivated: "/register/accountActivated",
  activationFailed: "/register/activationFailed",
  activationLinkExpired: "/activationLinkExpired",
  404: "/404",
  changeEmailConfirmation: "/changeEmailConfirmation",
  myAccount: "/myAccount",
  forgotPassword: "/login/forgotPassword",
  resetEmailConfirmation: "/login/resetEmailConfirmation",
  resetPassword: "/login/resetPassword/:token",
  changeEmail: "/changeEmail",
  installerView: "/installerView",
  installerViewLoggedIn: "/installerViewLoggedIn",
  project: "/project/:id",

  /** Footer links for  Customer services, Terms and conditions, Privacy policy**/
  customerServicesLink: "https://www.niko.eu/en/need-help/customer-services",
  termsAndConditionsLink: "https://www.niko.eu/en/legal",
  privacyPolicyLink: "https://www.niko.eu/en/legal/privacy-policy"
};

export type LanguageStrings = typeof baseLanguage;
export const en = baseLanguage;
